module.exports = __webpack_public_path__ + "static/GlitchlessSonyax4d-0775a761bb9d540ddff008d90c0eb947.png";